import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { getUserData, clearUserData } from "../utils/secureStroge";

function Header() {
  const [sticky, setSticky] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const handleScroll = () => setSticky(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const authData = getUserData();
    setUser(authData);
  }, []);

  const handleLogout = () => {
    clearUserData();
    setUser(null);
    window.dispatchEvent(new Event("authChanged"));
    window.location.href = "/";
  };

  useEffect(() => {
    const updateUser = () => {
      const authData = getUserData();
      setUser(authData);
    };

    updateUser();

    window.addEventListener("authChanged", updateUser);

    return () => window.removeEventListener("authChanged", updateUser);
  }, []);

  return (
    <div className={`page-wrapper ${mobileOpen ? "mobile-menu-visible" : ""}`}>
      <header className={`header home_five ${sticky ? "fixed_header" : ""}`}>
        <div className="main_header">
          <div className="container">
            <div className="main_header_inner d-flex align-items-center justify-content-between">
              {/* Logo */}
              <div className="main_header_logo">
                <NavLink to="/">
                  <img src="/images/logo.png" alt="eco-mantra-capital Logo" />
                </NavLink>
              </div>

              {/* Navigation */}
              <div className="main_header_menu menu_area">
                {/* Mobile Navigation Toggler */}
                <div
                  className="mobile-nav-toggler"
                  onClick={() => setMobileOpen(true)}
                >
                  <div className="menu-bar">
                    <i className="fas fa-bars"></i>
                  </div>
                </div>

                <nav className="main-menu">
                  <ul className="navigation navbar-nav">
                    <li>
                      <NavLink to="/" className="nav-link">
                        Home
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/about" className="nav-link">
                        About Us
                      </NavLink>
                    </li>
                    <li className="nav-item dropdown">
                      <NavLink
                        to="/service"
                        className="nav-link dropdown-toggle"
                        data-bs-toggle="dropdown"
                      >
                        Services
                      </NavLink>
                      <ul className="dropdown-menu submenu">
                        <li>
                          <NavLink
                            to="/account-handling-services"
                            className="dropdown-item"
                          >
                            Account Handling Services
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/portfolio-management-services"
                            className="dropdown-item"
                          >
                            Portfolio Management Services
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/non-recourse-loan"
                            className="dropdown-item"
                          >
                            Arbitrage Non-Recourse Loan
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <NavLink to="/pricing" className="nav-link">
                        Pricing
                      </NavLink>
                    </li>
                    <li className="nav-item dropdown">
                      <NavLink
                        to="#"
                        className="nav-link dropdown-toggle"
                        data-bs-toggle="dropdown"
                      >
                        Strategies
                      </NavLink>
                      <ul className="dropdown-menu submenu">
                        <li>
                          <NavLink to="/Marketplace" className="dropdown-item">
                            Marketplace
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/CreateStrategy"
                            className="dropdown-item"
                          >
                            Create Strategy
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/MyStrategies" className="nav-link">
                            My Strategies
                          </NavLink>
                        </li>
                      </ul>
                    </li>

                    <li>
                      <NavLink to="/contact" className="nav-link">
                        Contact Us
                      </NavLink>
                    </li>
                  </ul>
                </nav>
              </div>

              {/* Right Content */}
              <div className="header_right_content">
                {user?.accessToken ? (
                  <div className="d-flex gap-2">
                    {/* Profile Button */}
                    <NavLink to="/profile" className="profile-btn">
                      MK
                    </NavLink>

                    {/* Logout Button */}
                    <button onClick={handleLogout} className="btn_style_one">
                      Logout
                    </button>
                  </div>
                ) : (
                  <a
                    href="#"
                    className="btn_style_one"
                    data-bs-toggle="modal"
                    data-bs-target="#authModal"
                  >
                    Get Started
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <div className="mobile-menu">
        <div
          className="menu-backdrop"
          onClick={() => setMobileOpen(false)}
        ></div>
        <div className="close-btn" onClick={() => setMobileOpen(false)}>
          ×
        </div>
        <nav className="menu-box">
          <div className="nav-logo">
            <NavLink to="/">
              <img src="/images/header-mobile-logo.png" alt="Mobile Logo" />
            </NavLink>
          </div>
          <ul className="navigation">
            <li>
              <NavLink to="/" onClick={() => setMobileOpen(false)}>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" onClick={() => setMobileOpen(false)}>
                About Us
              </NavLink>
            </li>

            {/* Dropdown with sub-menu */}
            <li className="dropdown">
              <NavLink to="/service" onClick={() => setMobileOpen(false)}>
                Services
              </NavLink>
              <span
                className="dropdown-btn"
                onClick={(e) => {
                  e.preventDefault();
                  e.currentTarget.classList.toggle("open");
                  const submenu = e.currentTarget.nextElementSibling;
                  submenu.style.display =
                    submenu.style.display === "block" ? "none" : "block";
                }}
              >
                <i className="fas fa-angle-right"></i>
              </span>
              <ul>
                <li>
                  <NavLink
                    to="/account-handling-services"
                    onClick={() => setMobileOpen(false)}
                  >
                    Account Handling Services
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/portfolio-management-services"
                    onClick={() => setMobileOpen(false)}
                  >
                    Portfolio Management Services
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/non-recourse-loan"
                    onClick={() => setMobileOpen(false)}
                  >
                    Arbitrage Non-Recourse Loan
                  </NavLink>
                </li>
              </ul>
            </li>
            <li>
              <NavLink to="/pricing" onClick={() => setMobileOpen(false)}>
                Pricing
              </NavLink>
            </li>
            {/* Dropdown with sub-menu */}
            <li className="dropdown">
              <NavLink to="#" onClick={() => setMobileOpen(false)}>
                Strategies
              </NavLink>
              <span
                className="dropdown-btn"
                onClick={(e) => {
                  e.preventDefault();
                  e.currentTarget.classList.toggle("open");
                  const submenu = e.currentTarget.nextElementSibling;
                  submenu.style.display =
                    submenu.style.display === "block" ? "none" : "block";
                }}
              >
                <i className="fas fa-angle-right"></i>
              </span>
              <ul>
                <li>
                  <NavLink
                    to="/Marketplace"
                    onClick={() => setMobileOpen(false)}
                  >
                    Marketplace
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/CreateStrategy"
                    onClick={() => setMobileOpen(false)}
                  >
                    Create Strategy
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/MyStrategies"
                    onClick={() => setMobileOpen(false)}
                  >
                    My Strategies
                  </NavLink>
                </li>
              </ul>
            </li>
            <li>
              <NavLink to="/contact" onClick={() => setMobileOpen(false)}>
                Contact Us
              </NavLink>
            </li>
          </ul>

          <div className="contact-info">
            <h4>Contact Info</h4>
            <ul>
              <li>Mumbai, Maharashtra, India</li>
              <li>
                <a href="tel:+919876543210">+91 98765 43210</a>
              </li>
              <li>
                <a href="mailto:support@ecomantracap.com">
                  support@ecomantracap.com
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Header;
